import React, { useEffect } from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import colorChats from '../../lib/colorChats'
import { useState } from 'react'

var tituloGrafico = ''

const options = {
  legend: {
    display: true,
    position: 'top'
  },
  tooltips: {
    enabled: true,
    callbacks: {
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index]
      },
      label: function(tooltipItem, data) {
        // console.log(data.datasets);
        let label = data.datasets[tooltipItem.datasetIndex].label
        return label
      },
      afterLabel: function(tooltipItem, data) {
        let valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        return parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
      },
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          display: false,
          min: 0
        },        
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.1)"
        }
      }
    ],
    xAxes: [
      {
        barPercentage: 0.8,
        gridLines: {
          drawBorder: true,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          display: true
        }
      }
    ]
  }
}

const VerticalBar = ({ title, color, dados }) => {
  var data='';

  tituloGrafico = title;

  const [totalGrafico, setTotalGrafico] = useState(0);

  useEffect(()=>{
    let total = 0;
    // if(dados.valores){
    //   dados.valores.map(valor=>{
    //     total += Number(valor)
    //   })

    //   if(title === "Atendimento por Quantidade"){
    //     total = 'Total: ' + total;
    //   }else{
    //     //total = 'R$ ' + total.toFixed(2);
    //     total = parseFloat(total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    //   }

    //   setTotalGrafico(total);
    // }

    if (dados.total) {
      total = parseFloat(dados.total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      setTotalGrafico(total);
    }
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  if (typeof dados != "undefined") {

    data = {
      labels:dados.lojas,
      datasets: [
        {
          label: 'Valor Cliente',
          pointRadius: "0",
          pointHoverRadius: "0",
          backgroundColor: colorChats.vivida[1],
          borderWidth: "0",
          data: dados.valor1
        },
        {
          label: 'Valor Ministério da Saúde',
          pointRadius: "0",
          pointHoverRadius: "0",
          backgroundColor: colorChats.vivida[2],
          borderWidth: "0",
          data: dados.valor2
        }
      ]
    }
  
  } else {
      return (<></>)
  }

  return (
    <Card className='mb-0 mt-4'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor">{totalGrafico}</div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Bar
          data={data}
          options={options}
          width={550}
          height={150}
        />
      </CardBody>
    </Card>
  )
}

export default VerticalBar
